// Canonical paths for the docs surface. The Welcome page is the docs home and
// lives at `/docs` (not the verbose `/docs/getting-started/welcome`), so links
// and the Docs tab point there and the long URL redirects to it.

export const DOCS_HOME_SLUG = 'getting-started/welcome'
export const DOCS_HOME = '/docs'

/** Public path for a docs page slug, mapping the Welcome slug to the docs home. */
export function docPath(slug: string): string {
  return slug === DOCS_HOME_SLUG ? DOCS_HOME : `${DOCS_HOME}/${slug}`
}

/**
 * Slugs that used to be pages and now live inside another article. The docs
 * route 308s these to their new home so old links, search results, and the
 * Ask AI citations keep resolving. Keys must not be live slugs; values must be.
 */
export const DOCS_SLUG_REDIRECTS: Readonly<Record<string, string>> = {
  // Merged: the Finder-import paragraph was duplicated verbatim in both pages;
  // moving a selection now lives on canvas/selection.
  'canvas/drag-and-drop': 'canvas/uploading',
}
